import React from 'react';
import clsx from 'clsx';
import style from './style.module.scss';

const HockeyViewRecord = ({ item }) => {
  const { teams } = item;
  const { home, away } = teams;

  return (
    <>
      <dl className={style.item}>
        <dt>순위</dt>
        <dd
          className={clsx(
            away.seasonRecord.ranking < home.seasonRecord.ranking && style.on
          )}
        >
          {away.seasonRecord.ranking}위
        </dd>
        <dd
          className={clsx(
            home.seasonRecord.ranking < away.seasonRecord.ranking && style.on
          )}
        >
          {home.seasonRecord.ranking}위
        </dd>
      </dl>

      <dl className={style.item}>
        <dt>경기수</dt>
        <dd>{away.seasonRecord.gameCount}</dd>
        <dd>{home.seasonRecord.gameCount}</dd>
      </dl>

      <dl className={style.item}>
        <dt>승점</dt>
        <dd>{away.seasonRecord.point}</dd>
        <dd>{home.seasonRecord.point}</dd>
      </dl>

      <dl className={style.item}>
        <dt>승</dt>
        <dd>{away.seasonRecord.winCount}</dd>
        <dd>{home.seasonRecord.winCount}</dd>
      </dl>

      <dl className={style.item}>
        <dt>패</dt>
        <dd>{away.seasonRecord.defeatCount}</dd>
        <dd>{home.seasonRecord.defeatCount}</dd>
      </dl>

      <dl className={style.item}>
        <dt>연장승</dt>
        <dd>
          {away.seasonRecord.extraWinCount}
        </dd>
        <dd>
          {home.seasonRecord.extraWinCount}
        </dd>
      </dl>

      <dl className={style.item}>
        <dt>연장패</dt>
        <dd>
          {away.seasonRecord.extraDefeatCount}
        </dd>
        <dd>
          {home.seasonRecord.extraDefeatCount}
        </dd>
      </dl>

      <dl className={style.item}>
        <dt>득점</dt>
        <dd>
          {away.seasonRecord.totalGetScore}
        </dd>
        <dd>
          {home.seasonRecord.totalGetScore}
        </dd>
      </dl>

      <dl className={style.item}>
        <dt>실점</dt>
        <dd>
          {away.seasonRecord.totalLoseScore}
        </dd>
        <dd>
          {home.seasonRecord.totalLoseScore}
        </dd>
      </dl>
    </>
  );
};

export default HockeyViewRecord;
